import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiCall } from "../Apis/apiCall";
import { handleApiResponse, handleCustomResponse } from "../utils/response";
import { Icon } from "@iconify/react/dist/iconify.js";
import Breadcrumb from "../components/Breadcrumb";
import { CancelButtonForm, UpdateButtonForm } from "../components/ui/Button";

const AddRolePage = () => {
  const [roleName, setRoleName] = useState("");
  const [description, setDescription] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [saveLoading, setSaveLoading] = useState(false);
  const navigate = useNavigate();

  const isFormValid = () => {
    return roleName.trim() !== "" && description.trim() !== "";
  };

  const handleAddRole = async (e) => {
    e.preventDefault();

    if (!roleName.trim() || !description.trim()) {
      setErrorMessage("All fields are required.");
      return;
    }

    try {
      setSaveLoading(true);
      const response = await apiCall(
        "post",
        "/create-role",
        { role_name: roleName, description },
        navigate
      );

      if (response?.data?.success) {
        handleApiResponse(response.data, "success", "POST");
        // setSuccessMessage("Role added successfully!");
        setErrorMessage("");
        setRoleName("");
        setDescription("");
        setTimeout(() => {
          navigate("/all-roles");
        }, 1000);
      } else {
        handleCustomResponse("error", "Failed to add role.");
        setErrorMessage(response?.data?.message || "Failed to add role.");
      }
    } catch (error) {
      handleApiResponse(error.response?.data, "Err", "POST");
      setErrorMessage(error.response?.data?.message || "Error adding role.");
      setSuccessMessage("");
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb title="Add Role" />

      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          {errorMessage && (
            <div
              className="alert alert-danger alert-dismissible fade show mb-3"
              role="alert"
            >
              {errorMessage}
              <button
                type="button"
                className="btn-close"
                onClick={() => setErrorMessage("")}
              ></button>
            </div>
          )}
          {successMessage && (
            <div
              className="alert alert-success alert-dismissible fade show mb-3"
              role="alert"
            >
              {successMessage}
              <button
                type="button"
                className="btn-close"
                onClick={() => setSuccessMessage("")}
              ></button>
            </div>
          )}
          <form onSubmit={handleAddRole} autoComplete="off">
            <div className="row g-20">
              <div className="col-md-6 mb-20">
                <label htmlFor="roleName" className="form-label">
                  Role Name *
                </label>
                <input
                  id="roleName"
                  type="text"
                  className="form-control radius-8"
                  value={roleName}
                  onChange={(e) => setRoleName(e.target.value)}
                  placeholder="Enter role name"
                  disabled={saveLoading}
                />
              </div>
              <div className="col-md-6 mb-20">
                <label htmlFor="description" className="form-label">
                  Description *
                </label>
                <textarea
                  id="description"
                  className="form-control radius-8"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter description"
                  rows="3"
                  disabled={saveLoading}
                />
              </div>
            </div>
            <div className="d-flex justify-content-center gap-3">
              <CancelButtonForm onClick={() => navigate("/all-roles")} />
              <UpdateButtonForm
                // disabled={saveLoading || !isFormValid()}
                text={saveLoading ? "Please wait..." : "Add Role"}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddRolePage;